// extracted by mini-css-extract-plugin
export default {"googleAuthPaste":"style_googleAuthPaste__sV7OM","googleAuthError":"style_googleAuthError__kIwbd","googleAuthStatus":"style_googleAuthStatus__AkX8n"};